import React from 'react';

const bandFor = (score) => {
  if (score == null) return { label: '—', bg: 'rgba(148,163,184,0.18)', text: '#94a3b8', border: 'rgba(148,163,184,0.4)' };
  if (score >= 0.95) return { label: `${Math.round(score * 100)}%`, bg: 'rgba(34,197,94,0.18)', text: '#22c55e', border: 'rgba(34,197,94,0.4)' };
  if (score >= 0.80) return { label: `${Math.round(score * 100)}%`, bg: 'rgba(234,179,8,0.18)', text: '#eab308', border: 'rgba(234,179,8,0.4)' };
  return { label: `${Math.round(score * 100)}%`, bg: 'rgba(239,68,68,0.18)', text: '#ef4444', border: 'rgba(239,68,68,0.4)' };
};

const tooltipText = (score, citedCount, overrideCount) => {
  if (score == null && (!citedCount || citedCount === 0)) {
    return 'No citations yet — trust score will appear after this rule is used in classifications';
  }
  const pct = score == null ? 'n/a' : `${(score * 100).toFixed(1)}%`;
  return `Trust ${pct} · cited ${citedCount} time${citedCount === 1 ? '' : 's'}, ${overrideCount} analyst override${overrideCount === 1 ? '' : 's'}`;
};

export default function TrustScoreBadge({ trustScore, citedCount = 0, overrideCount = 0, size = 'sm' }) {
  const band = bandFor(trustScore);
  const padding = size === 'md' ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]';
  return (
    <span
      className={`inline-flex items-center font-mono font-semibold rounded ${padding}`}
      style={{
        background: band.bg,
        color: band.text,
        border: `1px solid ${band.border}`,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
      title={tooltipText(trustScore, citedCount, overrideCount)}
    >
      {band.label}
    </span>
  );
}
